const ProductPermissions = {
  edit: 'product:edit',
  create: 'product:create',
  delete: 'product:delete',
  view: 'product:view',
}

export default ProductPermissions
